<template>
    <APopunder :enabled="enabled" :href="href" @beforepop="beforePop">
        <slot />
    </APopunder>
</template>

<script>
import APopunder from "./APopunder.vue";
import cookies from "../../helpers/cookies";

export default {
    name: 'PopunderZone',
    components: {APopunder},
    props: {
        enabled: {type: Boolean, default: true},
        entity: {type: Object, default: null},
    },

    computed: {
        resolvedEntity() {
            const ua = window.navigator.userAgent.toLowerCase();
            const isChrome = ua.includes('crios') || (ua.includes("chrome") && !!window.chrome);

            if (isChrome && !(this.entity && this.entity.chrome)) {
                return null;
            }

            if (this.entity && cookies.get('_poPu_' + this.entity.zone, 'yes')) {
                return null;
            }

            return this.entity;
        },

        href() {
            return this.resolvedEntity && this.resolvedEntity.link;
        },
    },

    methods: {
        beforePop() {
            cookies.set('_poPu_' + this.resolvedEntity.zone, 'yes');
            window.gtag('event', 'click', {event_category: 'Pop under', event_label: this.resolvedEntity.zone});
        },
    },
}
</script>
